import React from 'react'
import BtnClose from 'src/assets/img/house/close.svg'
import PropTypes from 'prop-types'

const CloseButton = ({ onClose }) => {
  return (
    <div onClick={onClose} className="w-12 h-12 absolute -top-4 -right-4 z-50 cursor-pointer">
      <img className="w-full h-full" src={BtnClose} alt="close" />
    </div>
  )
}

CloseButton.propTypes = {
  onClose: PropTypes.func
}

export default CloseButton
